var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83899 14.0453C10.747 14.0453 12.2758 12.5321 12.2758 10.6575L12.2873 3.88194C12.2873 2.00736 10.747 0.494141 8.83899 0.494141C6.93093 0.494141 5.39069 2.00736 5.39069 3.88194V10.6575C5.39069 12.5321 6.93093 14.0453 8.83899 14.0453ZM14.931 10.6575C14.931 14.0453 12.0114 16.4168 8.83899 16.4168C5.66656 16.4168 2.747 14.0453 2.747 10.6575H0.792969C0.792969 14.5083 3.91942 17.6929 7.68955 18.2462V21.9502H9.98842V18.2462C13.7585 17.7041 16.885 14.5196 16.885 10.6575H14.931Z",
    fill: "#004BA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOn);
export default __webpack_public_path__ + "static/media/MicrophoneOn.cc7ebad3.svg";
export { ForwardRef as ReactComponent };